<template>
  <section id="xmain-content">
    <div class="formplain-wrapper">
      <div class="panel panel-default">
        <div
          v-if="formSchema.form.showPanelHeader"
          class="panel-heading"
        >
          <h3 class="panel-title">
            {{ formSchema.pages[0].title }}
          </h3>
        </div>

        <div class="panel-body">
          <vue-form-generator
            :ref="'vfg'"
            tag="div"
            :schema="formSchema.pages[0].schema"
            :model="formSchema.model"
            :options="formSchema.options"
          >
          </vue-form-generator>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
      
    // import VueFormGenerator from "vue-form-generator";
    Vue.use(VueFormGenerator);
    
    export default {
        name: "PlainForm",
        methods: {
            onComplete: function() {
                // TODO change to an emit
                this.$parent.onComplete()
         },
            
            validate: function() {
                 return this.$refs['vfg'].validate()
            }
        },

        // components: {  },

        // beforeCreate() {

        // }, 

        // created() {

        // }, 

        // beforeMount() {

        // },  

        // mounted() {

        // },

        // beforeDestroy() {

        // },  

        // destroyed() {

        // },
        
        props: ['formSchema' ],
        
        data: function() {
            return {
                showPanelHeader: true,

                // model: this.$parent.formSchema.model,

                // schema: this.$parent.formSchema.pages[0].schema,

                // options: this.$parent.formSchema.options

            }
        }

    }

</script>

<style>
    
</style>
